
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/threads-keyword-auto-reply",
      function () {
        return require("private-next-pages/features/threads-keyword-auto-reply/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/threads-keyword-auto-reply"])
      });
    }
  